import logoutIcon from '@iconify/icons-heroicons-outline/logout';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import DrawerLayout, { Position } from '@components/DrawerLayout';
import MemoizedIcon from '@components/MemoizedIcon';
import useMediaQuery from '@hooks/useMediaQuery';
import useSidebarConfig from '@hooks/useSidebarConfig';
import { MAX_WIDTH_SM } from '@src/constants';
import { useAuthenticationContext } from '@src/context/AuthenticationContext';

import Profile from './Profile';
import RecursiveMenu from './RecursiveMenu';

type Props = {
  isSidebarOpen: boolean;
  closeSidebar: () => void;
};

const Sidebar: FC<Props> = ({ isSidebarOpen, closeSidebar }) => {
  const { t } = useTranslation();

  const { doLogout } = useAuthenticationContext();
  const isMobile = useMediaQuery(MAX_WIDTH_SM);
  const { configs: sidebarConfig } = useSidebarConfig();

  return (
    <DrawerLayout
      key="sidebar"
      isOpen={isSidebarOpen}
      setIsOpen={() => closeSidebar()}
      childKey="drawer-content"
      defaultPadding={false}
      defaultVerticalPadding={false}
      withHeaderSeparator
      position={Position.Left}
      onClose={closeSidebar}
      drawerHeader={
        <h6 className="text-[16px] sm:text-[18px] font-semibold uppercase ml-5 py-5">
          {t('sidebar.main_menu')}
        </h6>
      }
    >
      <div className="flex flex-col justify-between h-full">
        <div>
          {isMobile && <Profile />}
          <RecursiveMenu
            menuConfigs={sidebarConfig}
            closeSidebar={closeSidebar}
          />
        </div>

        <button
          className={
            'flex hover:bg-primary-hover px-5 py-4 cursor-pointer bg-white hover:bg-neutral-30'
          }
          onClick={() => doLogout?.()}
          data-testid={'side-menu-logout'}
        >
          <MemoizedIcon
            icon={logoutIcon}
            className="text-danger-500 h-6 w-6 mr-4"
          />
          <div className="text-red-500">{t('sidebar.logout')}</div>
        </button>
      </div>
    </DrawerLayout>
  );
};

export default Sidebar;
